import { LOGO_FRAME, LOGO_LEAF, LOGO_WORDMARK } from "./logoPaths";

// Single swap point for the brand mark; geometry traced from the user's logo (2000×670 source coordinates).
export const Logo = ({ iconOnly = false, className = "h-8", color = "#111111", testId = "logo" }) => (
  <svg
    viewBox={iconOnly ? "233 118 297 412" : "233 118 1542 412"}
    className={`block w-auto ${className}`}
    role="img"
    aria-label="condoor"
    data-testid={testId}
  >
    <path d={LOGO_FRAME} fill={color} />
    <path d={LOGO_LEAF} fill={color} />
    {!iconOnly && <path d={LOGO_WORDMARK} fill={color} />}
  </svg>
);
